//-------------------------------------------------------------------------------------------------------------------------------
export const FETCHING = "EXTERNAL_FETCHING";
export const AUTHENTICATION = "EXTERNAL_AUTHENTICATION";
export const AUTHORISATION = "EXTERNAL_AUTHORISATION";
export const TOKEN_TIME_VALID = "EXTERNAL_TOKEN_TIME_VALID";
export const ERROR = "EXTERNAL_ERROR";
export const MAINTENANCE = "EXTERNAL_MAINTENANCE";
export const SHOW = "EXTERNAL_SHOW";
export function createAction_ExternalFetching(isFetching) {
    return {
        type: FETCHING,
        isFetching: isFetching
    };
}
export function createAction_ExternalAuthentication(isAuthenticated) {
    return {
        type: AUTHENTICATION,
        isAuthenticated: isAuthenticated
    };
}
export function createAction_ExternalAuthorisation(isAuthorised) {
    return {
        type: AUTHORISATION,
        isAuthorised: isAuthorised
    };
}
export function createAction_ExternalTokenTimeValid(isTokenTimeValid) {
    return {
        type: TOKEN_TIME_VALID,
        isTokenTimeValid: isTokenTimeValid
    };
}
export function createAction_ExternalError(isInError) {
    return {
        type: ERROR,
        isInError: isInError
    };
}
export function createAction_ExternalUnderMaintenance(isUnderMaintenance, underMaintenanceMessage) {
    return {
        type: MAINTENANCE,
        isUnderMaintenance: isUnderMaintenance,
        underMaintenanceMessage: underMaintenanceMessage
    };
}
export function createAction_ShowExternal() {
    return {
        type: SHOW
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
